import { computed, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DocumentItem } from '@klubovna/shared-models';
import { DocumentsFacade } from '../store/documents/documents.facade';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private readonly documentsFacade: DocumentsFacade = inject(DocumentsFacade);
  private documentsSigInternal: Signal<DocumentItem[] | undefined> = toSignal(this.documentsFacade.documents$);

  currentIdentifierSig: WritableSignal<string | null> = signal(null);

  documentsLoadingSig: Signal<boolean | undefined> = toSignal(this.documentsFacade.loading$);

  documentsSig: Signal<DocumentItem[]> = computed(() => {
    const documents = [ ...(this.documentsSigInternal() ?? []) ];
    return documents.filter((doc) => doc.isActive);
  });

  documentByIdentifier: Signal<DocumentItem | null> = computed(() => {
    if (this.currentIdentifierSig() && this.documentsSig().length > 0) {
      return this.documentsSig()?.find((d) => d.identifier === this.currentIdentifierSig()) ?? null;
    }
    return null;
  });

  setCurrentIdentifierSignal(signalValue: string | null): void {
    this.currentIdentifierSig.update(() => signalValue);
  }

  loadDocuments(): void {
    this.documentsFacade.loadDocuments();
  }
}
